<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Gebäudeart
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <option-list :options="options" :title="optionsTitle" module="gebaeudeart" @select="optionSelected"></option-list>
      </div>

      <div class="gp-right-column">
        <big-option-list
          v-slot="{ option }"
          module="gebaeudeart"
          stateKey="secondarySelection"
          :options="secondaryOptions"
          title="Materialstärke auswählen"
          :disableAlternativeHeaders="true"
          @select="selectSecondaryOption"
        >
          {{ texts[`1.${option.name}`] }}
        </big-option-list>
      </div>
    </div>
  </section>
</template>

<script>
import BigOptionList from "../components/BigOptionList.vue";
import OptionList from "../components/OptionList.vue";
import SectionContent from "../components/SectionContent.vue";
export default {
  components: { SectionContent, OptionList, BigOptionList },
  name: "Gebaeudeart",

  async created() {
    await this.$store.dispatch("gebaeudeart/fetchOptions");
    this.$store.dispatch("gebaeudeart/selectOption", this.options[0]);
    this.$store.dispatch("gebaeudeart/selectSecondaryOption", this.options[0].options[0]);
    this.$store.dispatch("zusammenstellung/fetchItemsAllItemsForModule", { module: "gebaeudeart", store: this.$store });
  },

  data() {
    return {
      roofArea: 15,
    };
  },

  computed: {
    texts() {
      return this.$store.state.inhalt.texts;
    },

    mainTitle() {
      return "Der passende Kleber";
    },

    optionsTitle() {
      return "Um welche Art von Gebäude handelt es sich?";
    },

    body() {
      return "Condimentum dapibus urna sodales elit dignissim sociosqu nunc finibus dictum fusce adipiscing taciti felis sed a magna vulputate lectus inceptos, malesuada volutpat platea lobortis praesent per lacinia senectus.";
    },

    options() {
      return this.$store.state.gebaeudeart.options;
    },

    secondaryOptions() {
      let options = this.$store.state.gebaeudeart.selection.options;
      if (!options) return [];

      return options
        .filter((option) => {
          return option.name !== "";
        })
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },

  methods: {
    optionSelected(option) {
      this.$store.dispatch("gebaeudeart/selectOption", option);
      this.$store.dispatch("gebaeudeart/selectSecondaryOption", option.options[0]);
    },

    selectSecondaryOption(option) {
      this.$store.dispatch("gebaeudeart/selectSecondaryOption", option);
    },
  },

  props: ["position", "description"],
};
</script>

<style></style>
